import { Stack, styled } from '@mui/material'

export const dataViewClasses = {
  root: 'DataView-root',
  filterPanel: 'DataView-filterPanel',
  filterPannelInner: 'DataView-filterPanelInner',
  filterPannelInnerLeft: 'DataView-filterPanelInnerLeft',
  filterPannelInnerRight: 'DataView-filterPanelInnerRight',
  footerPanel: 'DataView-footerPanel'
}

export const DataViewStyled = styled(Stack)(({ theme }) => ({
  flex: 1,
  height: '100%',
  width: '100%',
  [`.${dataViewClasses.filterPanel}`]: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '8px',
    minHeight: 'var(--filter-bar-height, 40px)'
  },
  [`.${dataViewClasses.filterPannelInner}`]: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
    flexGrow: 1
  },
  [`.${dataViewClasses.filterPannelInnerRight}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexGrow: 1,
    justifyContent: 'end'
  },
  [`.${dataViewClasses.footerPanel}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  }
}))
